export const SCHEMA_NAME = "CivilPapersCriminalComplaints";

export const FIELDS = {
  CIVIL_PAPERS_CRIMINALCOMPLAINT_ID: "civilPapersCriminalcomplaintID",
  CIVIL_PAPER_ID: "civilPaperID",
  WARRANT_TYPE: "warrantType",
  JUVENILE_FLAG: "juvenileFlag",
  WARRANT_DATE: "warrantDate",
  EXTRADITABLE: "extraditable",
  EXTRADITION_AREA: "extraditionArea",
  WHEN_AVAILABLE: "whenAvailable",
};
